export default function LocationIcon({ size = 24 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_11695_33361'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='24'
      >
        <rect width='24' height='24' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_11695_33361)'>
        <path
          d='M12.0029 11.8574C12.5004 11.8574 12.9257 11.6803 13.2789 11.3259C13.6322 10.9716 13.8089 10.5457 13.8089 10.0482C13.8089 9.55069 13.6317 9.12527 13.2774 8.77194C12.923 8.41877 12.497 8.24219 11.9994 8.24219C11.5019 8.24219 11.0765 8.41935 10.7234 8.77369C10.37 9.12802 10.1934 9.55402 10.1934 10.0517C10.1934 10.5492 10.3705 10.9745 10.7249 11.3277C11.0792 11.6809 11.5052 11.8574 12.0029 11.8574ZM12.0011 19.5057C13.9575 17.7544 15.4545 16.0745 16.4924 14.4662C17.5302 12.8579 18.0491 11.4492 18.0491 10.2402C18.0491 8.41719 17.47 6.91852 16.3116 5.74419C15.1533 4.56985 13.7165 3.98269 12.0011 3.98269C10.2858 3.98269 8.84896 4.56985 7.69062 5.74419C6.53229 6.91852 5.95312 8.41719 5.95312 10.2402C5.95312 11.4492 6.47204 12.8579 7.50988 14.4662C8.54771 16.0745 10.0448 17.7544 12.0011 19.5057ZM12.0011 21.5017C9.48446 19.321 7.59729 17.2916 6.33962 15.4134C5.08196 13.5351 4.45312 11.8107 4.45312 10.2402C4.45312 7.93252 5.19954 6.06427 6.69237 4.63544C8.18537 3.2066 9.95496 2.49219 12.0011 2.49219C14.0473 2.49219 15.8169 3.2066 17.3099 4.63544C18.8027 6.06427 19.5491 7.93252 19.5491 10.2402C19.5491 11.8107 18.9203 13.5351 17.6626 15.4134C16.405 17.2916 14.5178 19.321 12.0011 21.5017Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
}
